var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 17.3334C0.833496 18.3459 1.65431 19.1667 2.66683 19.1667H14.9632L19.1668 14.9631V2.66671C19.1668 1.65419 18.346 0.833374 17.3335 0.833374H2.66683C1.65431 0.833374 0.833496 1.65419 0.833496 2.66671V17.3334ZM2.66683 2.66671H17.3335V12.75H14.5835C13.571 12.75 12.7502 13.5709 12.7502 14.5834V17.3334H2.66683V2.66671ZM14.5835 14.5834H16.9538L14.5835 16.9537V14.5834ZM5.41683 12.75V14.5834H10.9168V12.75H5.41683ZM5.41683 10.9167V9.08337H14.5835V10.9167H5.41683ZM5.41683 5.41671V7.25004H14.5835V5.41671H5.41683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.35d2e4cd.svg";
export { ForwardRef as ReactComponent };